import { getAllResidentialObjectTypesKeys } from './getAllResidentialObjectTypesKeys';
import { commercialObjectTypes } from '../../../browser/addform/scripts/enums';

const allResidentialObjectTypesKeys = getAllResidentialObjectTypesKeys();

export const getPropertyTypeByObjectType = (objectType: string) => {
  const isResidential = !!allResidentialObjectTypesKeys.find((type) => type === objectType);
  const isCommercial = !!commercialObjectTypes.find(({ key }) => key === objectType);

  if (isResidential) {
    return 'residential';
  } else if (isCommercial) {
    return 'commercial';
  }

  throw new Error(`Unknown object type ${objectType}`);
};
